module.exports = __webpack_public_path__ + "static/img/retail1.105dd6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/retail1.png
// module id = gaGO
// module chunks = 2